export default "__VITE_ASSET__CzDI1sxT__"